module.exports = __webpack_public_path__ + "img/sup_cardsetting_ewallet4.a9414f13.jpg";